import React from "react";
import { Reveal } from "../tools/Reveal";
import { RevealGroup } from "../tools/RevealGroup";
// styling imports
import wsiApp from "../images/webp/wsi-ss.webp";
import nasaApp from "../images/webp/nasa-image-tool-ss-3.webp";
// import openInNewIcon from "../images/open-in-new.svg";
import "../styles/Projects.scss";

function Projects() {
  return (
    <div className="projects-wrapper" id="projects">
      <RevealGroup>
        <div className="section-title-wrapper">
          <Reveal direction={"top"}>
            <h5 className="section-title">PROJECTS</h5>
            <h2 className="section-subtitle">Highlights from my journey</h2>
          </Reveal>
        </div>
        <div className="projects-list">
          <div className="project-wrapper">
            <div className="project-info-wrapper">
              <Reveal direction={"left"}>
                <strong className="project-title">
                  Aircraft Overflight Noise Tool
                </strong>
                <div className="project-description">
                  <p className="project-description-paragraph">
                    This web application was developed for the Australian
                    Government to inform residents near the new Western Sydney
                    International (Nancy-Bird Walton) Airport. Users can enter
                    an address or select a location on the map to view expected
                    flight frequency and noise levels, supported by visuals and
                    downloadable PDF reports. On the first day of publication of
                    the website, it has received up to 60,000 people and it was
                    one of the most proud moments of my life.
                  </p>
                  <p className="project-description-paragraph">
                    I was the lead frontend developer on this project,
                    responsible for client communication, code quality and
                    structure, accessibility, responsiveness, and implementing
                    the overall functionality and design. Unfortunately, the
                    code is confidential and not publicly available.
                  </p>
                  {/* <strong className="project-tech">Techonologies used:</strong>{" "}
              <ul>
                <li className="ab-tech-point">JavaScript</li>
                <li className="ab-tech-point">React</li>
                <li className="ab-tech-point">i18next</li>
              </ul> */}
                </div>
                <div className="project-live-link-wrapper">
                  <a
                    href="https://wsiflightpaths.aerlabs.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="project-live-link"
                  >
                    <button className="project-live-button">
                      Live Project
                    </button>
                  </a>
                </div>
              </Reveal>
            </div>
            <div className="project-img-wrapper">
              <Reveal direction={"right"}>
                <img
                  src={wsiApp}
                  alt="a website which includes a map and a sidebar with various information"
                  className="project-img"
                />
              </Reveal>
            </div>
          </div>
          <div className="project-wrapper">
            <div className="project-info-wrapper">
              <Reveal direction={"left"}>
                <strong className="project-title">Nasa Image Tool</strong>
                <div className="project-description">
                  <p className="project-description-paragraph">
                    NASA Image Tool is a web application that leverages NASA's
                    Open API to fetch and display high-quality images and
                    information about space-related topics. Users can enter
                    keywords (e.g., "Mars", "Nebula", "Apollo 11") into a search
                    bar, and the app dynamically displays a curated selection of
                    relevant images. Upon cliking on the images a new page will
                    open with the picture and the description of the image. This
                    project showcases API integration, dynamic content
                    rendering, and user-friendly search functionality.
                  </p>
                  {/* <strong className="project-tech">Techonologies used:</strong>
              <ul>
                <li className="ab-tech-point">JavaScript</li>
                <li className="ab-tech-point">React</li>
              </ul> */}
                </div>
                <div className="project-live-link-wrapper">
                  <a
                    href="https://nasa-image-tool.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                    className="project-live-link"
                  >
                    <button className="project-live-button">
                      Live Project
                    </button>
                  </a>
                  <a
                    href="https://github.com/Feridun12/React-technical-testing"
                    target="_blank"
                    rel="noreferrer"
                    className="project-live-link"
                  >
                    <button className="project-live-button">Github</button>
                  </a>
                </div>
              </Reveal>
            </div>
            <div className="project-img-wrapper">
              <Reveal direction={"right"}>
                <img
                  src={nasaApp}
                  alt="a website where nasa logo and a search bar is present"
                  className="project-img"
                />
              </Reveal>
            </div>
          </div>
        </div>
      </RevealGroup>
    </div>
  );
}

export default Projects;
